import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { SwitchStyles, applySwitchCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-switch',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxSwitchStyleDirective {
  componentStyle = input<{
    style: SwitchStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applySwitchCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
